import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Header from "./components/Header";
import HeroSection from "./components/HeroSection";
import About from "./components/About";
import Treatments from "./components/Treatments";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import FooterMobile from "./components/FooterMobile";

const App: React.FC = () => {
  return (
    <Router>
      <Header />
      <Routes>
        <Route path="/" element={<HeroSection />} />
        <Route path="/chi-sono" element={<About />} />
        <Route path="/le-pratiche" element={<Treatments />} />
        <Route path="/contatti" element={<Contact />} />
      </Routes>
      {/* Footer per Desktop */}
      <div className="hidden md:block mt-auto">
        <Footer />
      </div>
      {/* Footer per Mobile */}
      <div className="block md:hidden mt-auto">
        <FooterMobile />
      </div>
    </Router>
  );
};

export default App;
